import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const financasApi = axios.create({
  baseURL: `${BACKEND_URL}/api`,
  headers: { 'Content-Type': 'application/json' },
});

financasApi.interceptors.request.use((config) => {
  const token = localStorage.getItem('financas_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

financasApi.interceptors.response.use(
  (r) => r,
  (error) => {
    if (error?.response?.status === 401) {
      localStorage.removeItem('financas_token');
      localStorage.removeItem('financas_user');
      localStorage.removeItem('financas_empresa');
      if (!window.location.pathname.startsWith('/financas/login')) {
        window.location.href = '/financas/login';
      }
    }
    return Promise.reject(error);
  }
);

export default financasApi;
